package br.com.texeratx.boardgametimeapp.data.model.player

import kotlinx.serialization.Serializable

@Serializable
data class CreatePlayerRequest(
    val name: String,
    val nickname: String? = null,
    val imageUrl: String? = null,
    val birthday: String? = null,
    val phone: String? = null,
    val status: Int = 1,
)
